export enum IntegrationProvider {
  STRIPE,
  PAYPAL,
  RYFT,
  SOLIDGATE,
  EMERCHANTPAY,
  PAYMENTSENSE,
  JCC,
  PAYABL,
  RMS,
  TRUST,
  SQUARE,
  GLOBALPAY,
  MOLLIE,
  FYGARO,
  EPAY,
  APCOPAY,
  VIVA,
  HOBEX,
  FLITT,
  ABAPAYWAY,
  ROOTLINE,
  NEOSOFT,
  IOTSOFT,
  WITEC,
  WPOS,
  PURPLEI,
  SITEBOON,
  NBGPAY,
  TISSL,
  LOYVERSE,
  HUBRISE,
  CARDLINK,
  EUROBANK,
  WRAPP,
  CITYPAY,
  VRPAYMENT,
  WALLEE,
  ALPHABANK,
  CLEARACCEPT,
  MYPOS,
  PXP,
  GLADIUS,
}

export enum ReferenceType {
  ORDER,
  STANDALONE_PAYMENT,
  RESERVATION,
  VOUCHER_TOPUP,
}

export enum PaymentCompletedStatus {
  SUCCESS,
  FAILURE,
  CANCELLED,
}

export interface IntegrationInitiatePaymentResponse {
  checkoutUrl?: string;
  intentId?: string;
  paymentParams: IntegrationPaymentParams;
  paymentFormParams: IntegrationPaymentFormParams;
  paymentProviderIdentifier: string;
  paymentTransactionId: string;
  paymentMethod?: string;
  originDomain?: string;
  originType?: string;
  storeId?: number;
  storeAliasName?: string;
  referenceId?: string;
  referenceType?: string;
  integrationProvider?: string;
}

export interface IntegrationPaymentParams {
  PAYMENT_REFERENCE: string;
}

export interface IntegrationPaymentFormParams {
  storeId: number;
  storeAlias: string;
  accountId: string;
  merchantId: string;
  sharedSecret: string;
  serviceUrl: string;
  totalAmount: number;
  currency: string;
  clientReference: string;
  customerEmail: string;
  customerPhoneNumber?: any;
  description: string;
  orderId: string;
  orderType?: any;
  paymentId: string;
  paymentType?: any;
  responseUrl: string;
  callbackUrl: string;
  paymentServerUrl?: string;
  cancelUrl: string;
  version?: string;
  acquirerId?: string;
  formattedPurchaseAmount?: string;
  currencyExponent?: string;
  captureFlag?: string;
  signature?: string;
  signatureMethod?: string;

  // trust payments
  siteReference?: string;
  webserviceUser?: string;
  webservicePassword?: string;
  stProfile?: string;
  stDefaultProfile?: string;
  currencyIso3a?: string;
  mainAmount?: string;
  orderReference?: string;
  ruleIdentifiers?: string[];
  stextraUrlRedirectFields?: string[];
  successfulUrlRedirect?: string;
  declinedUrlRedirect?: string;
  errorUrlRedirect?: string;
  siteSecurityTimestamp?: string;
  siteSecurity?: string;

  // payment sense
  accessToken?: string;

  // fygaro
  jwt?: string;

  // epay
  posId?: string;
  username?: string;
  languageCode?: string;
  merchantReference?: string;
  parameters?: string;

  providerPaymentType?: string;
  successUrl?: string;
}
